import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getToken } from "../helper/storage";
import axios from "axios";
import { setUser } from "../Redux/slices/userSlice";
import { url } from "../Constants/api";

const validateToken = async (dispatch) => {
  const token = await getToken("USER_KEY");
  if (token) {
    try {
      const response = await axios.get(url.validateToken, {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log(response.data);
      dispatch(setUser({ ...response.data.userData, id: token }));
    } catch (err) {
      localStorage.removeItem("USER_KEY");
      throw new Error(false);
    }
  } else {
    throw new Error(false);
  }
};

const ProtectedComponent = ({ children }) => {
  const navigate = useNavigate();
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!user.id || !user.email) {
      validateToken(dispatch)
        .then(() => {
          if (!getToken("USER_KEY")) {
            navigate("/signin");
          }
        })
        .catch((err) => {
          localStorage.removeItem("USER_KEY");
          navigate("/signin");
        });
    }
  }, [user, dispatch, navigate]);

  return <>{user && children}</>;
};

export const UnprotectedRoute = ({ children }) => {
  const navigate = useNavigate();
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();

  useEffect(() => {
    if (user.id) {
      navigate("/");
    } else {
      validateToken(dispatch)
        .then(() => {
          if (getToken("USER_KEY")) {
            navigate("/");
          }
        })
        .catch((err) => {
          localStorage.removeItem("USER_KEY");
          // navigate("/signin");
        });
    }
  }, [user, dispatch, navigate]);

  return <>{user && children}</>;
};

export default ProtectedComponent;
